import { PageSkeleton } from '@navioworks/ui';

export function PageLoadingState({
  variant = 'table',
  showFilters = false,
}: {
  variant?: 'table' | 'cards' | 'detail';
  showFilters?: boolean;
}) {
  return (
    <PageSkeleton
      className="px-0 py-0"
      showFilters={showFilters}
      variant={variant}
      itemCount={6}
    />
  );
}
